import dayjs from 'dayjs';

export const calculateShippingDate = (start: number, end: number) => {
  if (typeof start !== 'number' || typeof end !== 'number') return null;

  let deliveryTimeFrom = start;
  let deliveryTimeTo = end;

  deliveryTimeFrom = Math.floor(deliveryTimeFrom);
  deliveryTimeTo = Math.floor(deliveryTimeTo);

  if (deliveryTimeFrom > deliveryTimeTo) {
    [deliveryTimeFrom, deliveryTimeTo] = [deliveryTimeTo, deliveryTimeFrom];
  }

  if (deliveryTimeFrom < 0 || deliveryTimeTo < 0 || isNaN(deliveryTimeFrom) || isNaN(deliveryTimeTo)) return null;

  return `${formatDate(dayjs().add(deliveryTimeFrom, 'day').toDate())} - ${formatDate(dayjs().add(deliveryTimeTo, 'day').toDate())}`;
};

const formatDate = (date: Date) => {
  const month = date.toLocaleString('en-US', {
    month: 'short',
  });
  const day = date.getDate();

  return `${month}. ${day}`;
};
